import { toast } from "react-toastify";
import { retrieveToken } from "../../../utils/storage";

class HttpClient {
  constructor() {
    this.base_url = process.env.REACT_APP_API_URL;
  }

  async fetchWrapper(url, _headers, options) {
    return await fetch(url, {
      method: options.method,
      mode: "cors",
      headers: _headers,
      body: options.body ? JSON.stringify(options.body) : null,
    });
  }

  async request(options) {
    const fullUrl = new URL(this.base_url + options.endpoint);
    if (options.extraSearchParams) {
      Object.keys(options.extraSearchParams).forEach((key, index) => {
        fullUrl.searchParams.append(key, options.extraSearchParams[key]);
      });
    }
    //costruzione headers
    const headers = new Headers();
    headers.append("Accept", "application/json; charset=utf-8");
    //header eventuale content-type custom
    const checkContentType = options.headers
      ? "Content-Type" in options.headers
      : false;
    if (!checkContentType) {
      headers.append("Content-Type", "application/json; charset=utf-8");
    }
    //Token se presente
    const token = retrieveToken();
    if (token) {
      headers.append("Authorization", `Bearer ${token}`);
    }

    if (options.extraHeader) {
      headers.append(options.extraHeader.key, options.extraHeader.value);
    }

    let response;
    try {
      response = await this.fetchWrapper(fullUrl.toString(), headers, options);
    } catch (error) {
      toast.error("Errore di Comunicazione");
      // if (error instanceof SyntaxError) {
      // } else if (error instanceof TypeError) {
      // } else {
      // }
      console.error(error);
      return {
        ok: false,
      };
    }

    if (options.type === "blob") {
      return await response.blob();
    }

    return {
      ok: response.ok,
      status: response.status,
      description: response.statusText,
      data:
        response.status !== 204
          ? await response.json()
          : console.log("response:", response),
    };
  }

  async get(endpoint, extraSearchParams, options) {
    return this.request({
      method: "GET",
      endpoint,
      extraSearchParams,
      ...options,
    });
  }

  async post(endpoint, body, extraSearchParams, options) {
    return this.request({
      method: "POST",
      endpoint,
      body,
      extraSearchParams,
      ...options,
    });
  }

  async put(endpoint, body, extraSearchParams, options) {
    return this.request({
      method: "PUT",
      endpoint,
      body,
      extraSearchParams,
      ...options,
    });
  }

  async patch(endpoint, body, extraSearchParams, options) {
    return this.request({
      method: "PATCH",
      endpoint,
      body,
      extraSearchParams,
      ...options,
    });
  }

  async delete(endpoint, extraSearchParams, options) {
    return this.request({
      method: "DELETE",
      endpoint,
      extraSearchParams,
      ...options,
    });
  }
}
const client = new HttpClient();
export default client;
